import { Component, OnInit, Input } from '@angular/core';
import { NgForm, ControlContainer } from '@angular/forms';
import { UnitsOfServiceService } from 'src/shared/services/units-of-service.service';
import { UnitsOfService } from 'src/shared/models/units-of-service.model';
import { AncillaryConfiguration } from 'src/shared/models/ancillary-configuration.model';
import { RoomType } from 'src/shared/models/room-type.model';
import { AcuityCategory } from 'src/shared/models/acuity-category.model';
import { Room } from 'src/shared/models/room.model';
import { CostCenterConfigurationService } from 'src/shared/services/cost-center-configuration.service';
import { Constants } from 'src/shared/utilities/constants.util';
import { ShiftScheduleService } from 'src/shared/services/shift-schedule.service';
import { ShiftSchedule } from 'src/shared/models/shift-schedule.model';
import { ExpandableListComboComponent } from 'src/shared/Baseclasses/expandable-list-combo.component';
import { ExpandableListItem } from 'src/shared/models/expandable-list-item.model';

@Component({
  selector: 'smt-ancillary',
  templateUrl: './ancillary.component.html',
  styleUrls: ['./ancillary.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class AncillaryComponent implements OnInit {
  @Input() configuration: AncillaryConfiguration;
  @Input() readOnly: boolean;

  methodOfWork = 'acuity';
  newRoomType = "";
  newAcuityCategory = "";
  newRoom: Room;
  unitsOfService: UnitsOfService[] = [];
  selectedUnitOfService: UnitsOfService;
  schedules: ShiftSchedule[];
  isRadioButtonReadOnly: string;
  confirmDeleteAcuityCategory: boolean;
  
  isFutureShiftBlockAvailable: boolean;

  confirmModalActive:boolean =false;
  rowNameToDelete: number;
  selectedExpandList: ExpandableListComboComponent;
  acuityCategoryColumns: string[] = [];
  acuityCategoryRows: ExpandableListItem[] = [];
  selectedAcuityCategories: AcuityCategory[] = [];

  roomInfoColumns :string[] = ['Order','Room Type' , 'Room Name'];
  roomInfoRows : ExpandableListItem[] = [];
  roomGroupArray: string[];
  selectedTypeOfAddOns: string;
  constructor(
    private _shiftScheduleService: ShiftScheduleService,
    private _unitsOfService: UnitsOfServiceService,
    private _costCenterConfigurationService: CostCenterConfigurationService) { }

  async ngOnInit() {
    this._costCenterConfigurationService.announceAdminActionLoading(true);
    this.unitsOfService = await this._unitsOfService.GetUnitsOfServices(false, 0, 50, "", "Category", "ASC");
    this._costCenterConfigurationService.announceAdminActionLoading(false);
    this.newRoom = new Room();
    this.loadSchedules();
    this._costCenterConfigurationService.isFutureShiftRecordPresent$.subscribe(isFutureShiftBlockAvailable=>{
      this.isFutureShiftBlockAvailable = isFutureShiftBlockAvailable;
      if(isFutureShiftBlockAvailable){
        this._costCenterConfigurationService.announceWarning(this._costCenterConfigurationService.staffingGridLockOutMessage);
          }
      else{
          this._costCenterConfigurationService.clearWarning();
      }
    });

    
    this.isRadioButtonReadOnly = this.readOnly ? 'disabled' : null;
    this.acuityCategoryColumns = ["Order","Name"];
    this.acuityCategoryRows = [];
    if(this.configuration){
      this.selectedAcuityCategories = this.configuration.acuityCategories;
      this.acuityCategoryRows = this.acuityCategoriesToExpandable(this.selectedAcuityCategories);
      this.roomInfoRows = this.loadRoomInfoRows;
      this.roomGroupArray= this.getRoomTypes;
    }
   else{
    this.selectedAcuityCategories = [];
    this.acuityCategoryRows=[];
   }

  }

  get hasConfiguration() {
    return this.configuration && !!this.configuration.id;
  }

  async loadSchedules(){
      if(this.configuration.costCenterId) {          
          this.schedules = await this._shiftScheduleService.getActiveShiftSchedulesByCostCenter(this.configuration.costCenterId);
      }
  }

  addRoomType(): boolean {
    this.configuration.roomTypes = this.configuration.roomTypes || [];
    
    if (this.newRoomType !== "") {
        if(this.configuration.roomTypes.find(r =>r.name === this.newRoomType)){
            this._costCenterConfigurationService.announceError("Cannot create room type with duplicate name.");
            return false;
        }
      this.configuration.roomTypes.push({
        name: this.newRoomType,
        rooms: []
      } as RoomType);
      this.roomGroupArray = this.getRoomTypes;
      this.newRoomType = '';
    }
    
    this.validate();
    return false;
  }

  removeRoomType(index: number): boolean {
    this.roomInfoRows = this.roomInfoRows.filter(f=>this.configuration.roomTypes[index].name!==f.groupby);      
    this.configuration.roomTypes.splice(index, 1);
    this.roomGroupArray = this.getRoomTypes;
    this._costCenterConfigurationService.announceFormIsDirty(true);
    this.validate();
    return false;
  }

  get isNewCostCenter(): boolean{
    return !this.configuration.id;
  }
  warnStaffingGridResets(){    
    if(!this.isNewCostCenter && this._shiftScheduleService.areSchedulesPresent(this.schedules)){
      this._costCenterConfigurationService.announceWarning(Constants.ResetStaffingGridWarning);
    }
  }

  roomInfoChangeEvent(rows : ExpandableListItem[]): boolean {
    let flag : boolean = false;
    rows.forEach((r,i)=>{
      let roomType = this.findRoomType(r.groupby);
      if(!this.configuration.roomTypes.some(s=>s.name==r.groupby)){
        this.configuration.roomTypes.push({
          name: this.newRoomType,
          rooms: [{id:r.id,roomTypeId:roomType.id,name:r.displayValue,order:i+1 }as Room]
        } as RoomType);
        flag = true;        
      }
      else{
        let roomType = this.configuration.roomTypes.find(f=>f.name==r.groupby);
        if(!roomType.rooms.some(s=>s.name==r.displayValue)){
        roomType.rooms.push({id:r.id,roomTypeId:roomType.id,order:i+1,name:r.displayValue } as Room);
        flag = true;
        }
        else{
          roomType.rooms.forEach(f=>{
            if(f.name== r.displayValue){
              f.order = i+1;
            }
          })
        }
      }
    });
    if(flag) this._costCenterConfigurationService.announceFormIsDirty(true);
    this._costCenterConfigurationService.clearError();
    this.validate();
    return false;
  }

  removeRoom($event :any) {
    let removedRoomInfo = this.findRoomType($event[1].groupby);
     removedRoomInfo.rooms = removedRoomInfo.rooms.filter(f=>f.name!==$event[1].displayValue);
    this._costCenterConfigurationService.announceFormIsDirty(true);
    $event[0].onComboRemove($event[1],true);
  }

  private findRoomType(roomTypeName: string): RoomType {
    let roomTypeIndex = this.configuration.roomTypes.findIndex(x => x.name == roomTypeName);
    let roomType = this.configuration.roomTypes[roomTypeIndex];
    return roomType;
  }

  get loadRoomInfoRows() : ExpandableListItem[]{
    let rooms : Room[]=[];
    this.configuration.roomTypes.forEach(rt=> {
      rt.rooms.forEach(f=>{
        f.roomTypeName = rt.name;
        rooms.push(f);
      })
    });
   return rooms.map(r=>({ id: r.id,groupby : r.roomTypeName,displayValue :r.name,order: r.order }as ExpandableListItem));
  }

  get getRoomTypes(): string[]{
    return this.configuration.roomTypes.map(n=>n.name);
  }
  get missingUosByBlock() : boolean {
    return !this.configuration.enterUOSByBlock && this.configuration.enterUOSByBlock !== false;
  }

  get missingAddOns() : boolean {
    return this.configuration.typeOfWorkTemplate === 'total'
        && (!this.configuration.addOns && this.configuration.addOns !== false);
  }

  get missingAcuityCategories() : boolean {
    return this.configuration.typeOfWorkTemplate === 'acuity'
      && (!this.configuration.acuityCategories || this.configuration.acuityCategories.length === 0)
  }

  get missingHasRoomTypesCheckbox() : boolean {
    return !this.configuration.hasRoomTypes && this.configuration.hasRoomTypes !== false;
  }

  get missingRooms() : boolean {
    if (this.configuration && this.configuration.hasRoomTypes === false) 
      return false;

    return !this.configuration
        || !this.configuration.roomTypes
        || !this.configuration.roomTypes.length
        || !this.configuration.roomTypes.every(r =>!!r.rooms.length);
  }

  get isValid() : boolean {
    if (this.configuration.typeOfWorkTemplate === 'total') {
      return !this.missingAddOns
          && !this.missingUosByBlock;
    } else if (this.configuration.typeOfWorkTemplate === 'acuity') {  
      return !this.missingHasRoomTypesCheckbox
        && !this.missingRooms
        && !this.missingAcuityCategories
        && !this.missingUosByBlock;
    }
  }
  onSelectTypeofWorkTemplete() {
    if (this.configuration.variableTargetWHPUOS || this.configuration.fixedTargetWHPUOS || this.totalTargetWHPUOS) {
      this.configuration.variableTargetWHPUOS = null;              
      this.configuration.fixedTargetWHPUOS = null;
}
    this.validate();
  }

  validate() {
    this._costCenterConfigurationService.announceFormIsValid(this.isValid);
  }

  get totalTargetWHPUOS(): number {
    if (this.configuration.variableTargetWHPUOS == null && this.configuration.fixedTargetWHPUOS == null) {
      return null;
    }
    return +this.configuration.fixedTargetWHPUOS + +this.configuration.variableTargetWHPUOS;
  }
  
  onChangeAddons() {
    this.warnStaffingGridResets()
    this.validate();
  }
  acuityCategoryChangeEvent(acuityCategoryRows: ExpandableListItem[]) { 
     if (this.configuration.acuityCategories === undefined) {
      this.configuration.acuityCategories= [];
    }
    if(!this.isFutureShiftBlockAvailable)
    {
          let namesToIgnore = this.configuration.acuityCategories.map(n => n.name);
          this._costCenterConfigurationService.announceFormIsDirty(true);
          if (acuityCategoryRows.length > this.configuration.acuityCategories.length) 
          {
            
              acuityCategoryRows.forEach(async (e: ExpandableListItem) => 
              {
                if (namesToIgnore.indexOf(e.displayValue) == -1) 
                {
                  let acuityCategory = acuityCategoryRows.find(v => v.displayValue == e.displayValue);
                  if(acuityCategory)
                  {
                      acuityCategory.order = this.configuration.acuityCategories.length + 1;
                      this.configuration.acuityCategories.push({
                        name: acuityCategory.displayValue,
                        order: acuityCategory.order
                      } as AcuityCategory);
                  }
                  this.warnStaffingGridResets();
                  return false;
                }
               
              });
          }
          else
            {
              this.configuration.acuityCategories = this.configuration.acuityCategories.filter(r => {
                var acuityCategory = acuityCategoryRows.find(n => n.displayValue == r.name);
                if (acuityCategory) {
                  r.order = acuityCategory.order;
                  return r !== undefined;
                }
              })
            }
           
            this._costCenterConfigurationService.announceFormIsValid(this.isValid); 
    }
    else{
      this._costCenterConfigurationService.announceWarning(this._costCenterConfigurationService.staffingGridLockOutMessage);
      return false;
    }
   
  }
  showAcuityWarning($event :any){
    this._costCenterConfigurationService.announceError("Cannot create activity category with duplicate name.");
  }
  showRoomInfoWarning($event:any){
    this._costCenterConfigurationService.announceError("Cannot create rooms with duplicate name for room type "+ $event);
  }
 acuityCategoriesToExpandable(acuityCategories: AcuityCategory[]): ExpandableListItem[] {
    let listItems: ExpandableListItem[] = [];
    if (!acuityCategories) {
      return listItems;
   }
   acuityCategories.forEach(a => {
     let listItem = new ExpandableListItem();
     listItem.id = a.id;
     listItem.displayValue = a.name ;
     listItem.cells = [{ value: a.name }];
     listItem.order = a.order;
     listItems.push(listItem);
   });

   return listItems;
  }
  markConfirmModalActive($event:any[]){
    if (!this.isFutureShiftBlockAvailable || this.isNewCostCenter) {
      let obj = <ExpandableListComboComponent>$event[0];
      let name = $event[1];
      this.rowNameToDelete = name;
      this.confirmModalActive = true;
      this.selectedExpandList = obj;
    }
    else{
      this._costCenterConfigurationService.announceWarning(this._costCenterConfigurationService.staffingGridLockOutMessage);
    }
  }
  confirmYes(name){
    this.configuration.acuityCategories = this.configuration.acuityCategories.filter(item =>item.name!=name)
    this.selectedExpandList.onComboRemove(name,true);
    this.confirmModalActive = false;
  }
  orderUpdated(orderType: string) {
    this._costCenterConfigurationService.announceFormIsDirty(true);
    if (orderType === "Activity Category") {
      this.configuration.isAcuityCategoriesOrderUpdated = true;
      this.configuration.acuityCategories.forEach(row => {
        var acuityCategory = this.acuityCategoryRows.find(f => f.displayValue == row.name);
        row.order = acuityCategory.order;
      });
    }
    if(orderType==="Room Name"){
      this.configuration.isRoomsOrderUpdated = true;
      this.configuration.roomTypes.forEach(rt=>{
        rt.rooms.forEach(r=>{
          if(this.roomInfoRows.some(s=>s.displayValue === r.name && s.groupby=== rt.name)){
            var thisRow = this.roomInfoRows.find(s=>s.displayValue === r.name && s.groupby=== rt.name);
            r.order = thisRow.order;
          }
        })
      });
    }
  }
}
 

